/* eslint-disable @typescript-eslint/no-duplicate-enum-values -- Duplicate values are temporary aliases. */

/**
 * Effectively a name for a deployed site. Although these names may be predictable,
 * this not a guarantee and should not be relied upon for any kind of logic.
 */
export enum SiteID {
  /** @deprecated Alias for backwards compatibility. */
  AHNU = 'AHNU-US',
  AHNU_US = 'AHNU-US',
  /** @deprecated Alias for backwards compatibility. */
  CONDUCTOR = 'CONDUCTOR-US',
  CONDUCTOR_US = 'CONDUCTOR-US',
  /** @deprecated Alias for backwards compatibility. */
  HOKA = 'HOKA-US',
  HOKA_US = 'HOKA-US',
  /** @deprecated Will be removed in HP-4549. */
  KOOLABURRA = 'KOOLABURRA',
  /** @deprecated Will be removed in HP-4549. */
  SANUK = 'SANUK',
  /** @deprecated Alias for backwards compatibility. */
  TEVA = 'TEVA-US',
  TEVA_US = 'TEVA-US',
  /** @deprecated Alias for backwards compatibility. */
  UGG = 'UGG-US',
  UGG_US = 'UGG-US',
  /** @deprecated Alias for backwards compatibility. */
  UGG_COLLAB = 'UGG-COLLAB-US',
  /** @deprecated Alias for backwards compatibility. */
  'UGG-COLLAB' = 'UGG-COLLAB-US',
  UGG_COLLAB_US = 'UGG-COLLAB-US'
}

/**
 * Tries to convert a string to a {@link SiteID}.
 * If the string is a lowercase version of a {@link SiteID}, it will
 * be converted to the corresponding {@link SiteID} value.
 * @param maybeSiteID - The string to convert.
 * @returns A {@link SiteID} if the conversion is successful, otherwise `null`.
 */
export function asSiteID(maybeSiteID: string): SiteID | null {
  maybeSiteID = maybeSiteID.toUpperCase();
  // check if the value can be trivially mapped to a SiteID
  if (maybeSiteID in SiteID) {
    return SiteID[maybeSiteID as keyof typeof SiteID];
  }
  // check if the value is already a SiteID
  return Object.values(SiteID).includes(maybeSiteID as SiteID)
    ? (maybeSiteID as SiteID)
    : null;
}
